import { http } from '@/lib/ats-https';

const createSharedEmail = async (payload) => {
  return http.post('/shared-emails', payload);
};

const listSharedEmail = async () => {
  return http.get('/shared-emails');
};

const updateSharedEmail = async (id, payload) => {
  return http.patch(`/shared-emails/${id}`, payload);
};

const deleteSharedEmail = async (id) => {
  return http.delete(`/shared-emails/${id}`);
};

const deleteDomains = async (id) => {
  return http.delete(`/email-domains/${id}`);
};
const getDomainDNSRecords = async ({ id }) => {
  const response = await http.get(`/email-domains/${id}/dns_records`);
  return response.data;
};

const setDefaultSharedEmail = async (id) => {
  const response = await http.put(`/shared-emails/${id}/make_default`);
  return response;
};

const verifyDomain = async (id) => {
  return http.put(`/email-domains/${id}/verify`);
};

const sendDNSRecordsViaEmail = async (id, payload) => {
  return http.post(`/email-domains/${id}/email_dns_records`, payload);
};

export const SHARED_EMAIL_API_SERVICES = {
  createSharedEmail,
  listSharedEmail,
  updateSharedEmail,
  deleteSharedEmail,
  deleteDomains,
  verifyDomain,
  sendDNSRecordsViaEmail,
  setDefaultSharedEmail,
  getDomainDNSRecords,
};
